module.exports = __webpack_public_path__ + "static/media/FIUCEC.e3f55c71.svg";